import React, { useState } from 'react';
import { Box, Drawer, Typography, useMediaQuery } from '@material-ui/core';

import UpArrow from '€icons/UpArrow';
import theme from '€theme/theme';
import { OfflineNotificationInfo } from '.';

const OfflineNotificationBanner: React.FC = () => {
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const [displayNotificationInfo, setDisplayNotificationInfo] = useState<boolean>(false);

    const openInfoPopup = event => {
        event.preventDefault();
        setDisplayNotificationInfo(true);
    };

    const handleInfoClose = () => {
        setDisplayNotificationInfo(false);
    };

    return (
        <>
            <Drawer
                variant="persistent"
                anchor="bottom"
                open
                onClick={openInfoPopup}
                style={{ cursor: 'pointer' }}
                PaperProps={{
                    style: {
                        overflowY: 'visible',
                    },
                }}
                data-testid="offline-drawer"
            >
                <Box
                    display="flex"
                    color="secondary.contrastText"
                    bgcolor="#000000"
                    py={0.5}
                    width="100%"
                    justifyContent={matches ? 'center' : 'space-between'}
                >
                    <Typography
                        variant="caption"
                        style={{
                            margin: matches ? '0px' : 'auto',
                            paddingLeft: matches ? '0px' : '1.5rem',
                        }}
                    >
                        You are currently set to offline
                    </Typography>
                    <Box
                        width="9px"
                        height="9px"
                        alignSelf="center"
                        ml={{ xs: 0, sm: 2 }}
                        mr={{ xs: 1.5, sm: 0 }}
                    >
                        {!displayNotificationInfo && <UpArrow width="100%" height="100%" />}
                    </Box>
                </Box>
            </Drawer>
            {displayNotificationInfo && (
                <OfflineNotificationInfo handleNotificationInfoClose={handleInfoClose} />
            )}
        </>
    );
};

export default OfflineNotificationBanner;
